<div class="ui-select">
  @if (label()) {
    <label class="ui-select__label" [attr.for]="id() || null">
      {{ label() | uiLabelTranslate }}
      @if (required()) {
        <span class="ui-select__required">*</span>
      }
    </label>
  }

  <div class="ui-select__wrapper">
    @if (multiple()) {
      <p-multiSelect
        #multiSelectRef
        [inputId]="id() || undefined"
        [disabled]="disabled()"
        [required]="required() && validateRequired()"
        [options]="resolvedOptions()"
        [ngModel]="values()"
        [optionLabel]="'translatedLabel'"
        [optionValue]="'value'"
        [optionDisabled]="'disabled'"
        [placeholder]="placeholder() | uiLabelTranslate"
        [display]="'chip'"
        [maxSelectedLabels]="5"
        [selectedItemsLabel]="'{0} selected'"
        [showToggleAll]="false"
        [filter]="searchable() || multiple()"
        [filterPlaceHolder]="searchPlaceholder() | uiLabelTranslate"
        [emptyMessage]="'No options found.' | uiLabelTranslate"
        [emptyFilterMessage]="'No options found.' | uiLabelTranslate"
        [appendTo]="'body'"
        [overlayOptions]="overlayOptions"
        [lazy]="loadMoreOnScroll()"
        [virtualScroll]="loadMoreOnScroll()"
        [virtualScrollItemSize]="virtualScrollItemSize()"
        [loading]="loadingMoreOptions()"
        [styleClass]="'ui-select__control'"
        [panelStyleClass]="'ui-select__panel'"
        (ngModelChange)="onValuesChange($event)"
        (onClick)="onMultiSelectClick()"
        (onShow)="onShow()"
        (onFilter)="onSearchChange($event)"
        (onLazyLoad)="onLazyLoad($event)"
      ></p-multiSelect>
    } @else {
      <p-select
        #selectRef
        [inputId]="id() || undefined"
        [disabled]="disabled()"
        [required]="required() && validateRequired()"
        [options]="resolvedOptions()"
        [ngModel]="value() || null"
        [optionLabel]="'translatedLabel'"
        [optionValue]="'value'"
        [optionDisabled]="'disabled'"
        [placeholder]="placeholder() | uiLabelTranslate"
        [filter]="searchable()"
        [filterPlaceholder]="searchPlaceholder() | uiLabelTranslate"
        [filterBy]="'translatedLabel'"
        [showClear]="false"
        [checkmark]="true"
        [emptyMessage]="'No options found.' | uiLabelTranslate"
        [appendTo]="'body'"
        [overlayOptions]="overlayOptions"
        [lazy]="loadMoreOnScroll()"
        [virtualScroll]="loadMoreOnScroll()"
        [virtualScrollItemSize]="virtualScrollItemSize()"
        [loading]="loadingMoreOptions()"
        [styleClass]="'ui-select__control'"
        [panelStyleClass]="'ui-select__panel'"
        (ngModelChange)="onValueChange($event)"
        (onShow)="onShow()"
        (onFilter)="onSearchChange($event)"
        (onLazyLoad)="onLazyLoad($event)"
      ></p-select>
    }
  </div>

  @if (error()) {
    <p class="ui-select__error">{{ error() | uiLabelTranslate }}</p>
  } @else if (hint()) {
    <p class="ui-select__hint">{{ hint() | uiLabelTranslate }}</p>
  }
</div>
